import { render } from "./OrderOutstandingBalanceModal.vue?vue&type=template&id=65d24e49"
import script from "./OrderOutstandingBalanceModal.vue?vue&type=script&lang=js"
export * from "./OrderOutstandingBalanceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__